import ColorsStyles from '@Styles/colors.scss';
import Switch, { SwitchClasses, SwitchProps } from '@mui/material/Switch';
import { styled } from '@mui/system';
// Import switchUnstyledClasses
import React from 'react';

const prefix_class = 'MuiSwitch';

export default function SwitchIIPStyledComponent(isActive: boolean = false) {
    return <Switch checked={isActive}></Switch>;
}
